import {RowSection, SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const CouponLandingPageHeaderLoadingMobile: React.FC<{
  className?: string;
}> = ({className}) => {
  return (
    <Container className={className}>
      <StyledSkeletonBlock />
    </Container>
  );
};

const Container = styled(RowSection)`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 170px;
`;

const StyledSkeletonBlock = styled(SkeletonBlock)`
  width: 100%;
  height: 100%;
`;
